import { useMemo } from "react"
import type { CombinedError } from "urql"
import { useQuery } from "urql"

import {
  GetStartPoDataDocument,
  type PurchaseOrderPricingInput,
  type PurchaseOrderPricingSuccess,
  type Query,
} from "@/graphql/codegen/graphql"

interface UseGetStartPODataReturn {
  pricingResult: PurchaseOrderPricingSuccess
  pricingFetching: boolean
  pricingError: CombinedError | undefined
}

export const useGetStartPOData = (input: PurchaseOrderPricingInput | null): UseGetStartPODataReturn => {
  const [{ data, fetching: pricingFetching, error: pricingError }] = useQuery<Pick<Query, "order">>({
    query: GetStartPoDataDocument,
    variables: { input: input! },
    pause: !input?.orderLines?.length || !input?.requestedDeliveryDate,
  })

  const pricingResult = useMemo<PurchaseOrderPricingSuccess>(
    () =>
      data?.order?.calculatePurchaseOrderPricing.__typename === "PurchaseOrderPricingSuccess"
        ? data.order.calculatePurchaseOrderPricing
        : { orderLines: [], requestedDeliveryDate: null, sourceCompanyLocationAssociationId: null, totals: null },
    [data?.order?.calculatePurchaseOrderPricing]
  )

  return {
    pricingResult,
    pricingFetching,
    pricingError,
  }
}
